import { Component, OnInit, inject } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseFormComponent } from '@classes/extends';
import { AnalysessupService as AnalysesSupplementairesService, ClientsService as ClientService, Contact, ContactService, ControleperfService as ControlePerformancesService, Document,
    DocumentEnvoyable, EnvoisService, Fichier, RFParam, RFTriDoc, Service, ServicesService, TypeFichier, Utilisateur, UtilService as UtilisateurService } from '@estel-numerique/galaclick-api';
import { TypeService } from '@estel-numerique/galaclick-core';
import { Constantes } from '@services/util/constantes';
import { FileSaverService } from 'ngx-filesaver';
import { lastValueFrom, Observable } from 'rxjs';
import { DocumentCodeEnum } from '../../enums/codeDocument.enum';
import { DocumentEnum } from '../../enums/document.enum';
import { DialogGalaComponent } from '../../../composants/dialog-gala/dialog-gala.component';
import { SelectGala } from '../../../composants/select/select.component';
import { MatButton } from '@angular/material/button';

export interface DocumentEnvoisComponentData {
    doc?: Document;
    controle?: {
        dateDoc: string;
        idClient: number;
        codeDocs: string[]
    }
    envoi: boolean;
}
@Component({
    selector: 'document-envois',
    templateUrl: 'document-envois.component.html',
    styleUrls: ['./document-envois.component.scss'],
    imports: [DialogGalaComponent, FormsModule, ReactiveFormsModule, SelectGala, MatButton]
})
export class DocumentEnvoisComponent extends BaseFormComponent implements OnInit {
    private wsSuivEnv = inject(EnvoisService);
    private wsContact = inject(ContactService);
    private wsUtilisateur = inject(UtilisateurService);
    private wsAnaSup = inject(AnalysesSupplementairesService);
    private wsControlePerformances = inject(ControlePerformancesService);
    private wsService = inject(ServicesService);
    private fileService = inject(FileSaverService);
    private wsClient = inject(ClientService);
    private formBuilder = inject(UntypedFormBuilder);
    private dialogRef = inject<MatDialogRef<DocumentEnvoisComponent>>(MatDialogRef);
    public data = inject<DocumentEnvoisComponentData>(MAT_DIALOG_DATA);

    public titre: string;
    // Traduction
    protected lgTrad: Record<string, string> = {};

    public document: Document[] = [];
    public formDoc: UntypedFormGroup;
    protected selectedDocument: Document; // document sélectionné dans la liste

    public boEnvoi = false;
    public boTest = false;
    public boOrdreTri = false;

    public selectTypeFichier: TypeFichier;
    public listeTypesFichiers: { label: string; value: TypeFichier }[];
    public listeDestinataire: RFParam[] = [];
    public listeDestinatairePrio: RFParam[] = [];
    public listeDocEnvoi: RFParam[] = [];
    public listeTEnvoiSave: RFParam[] = [];
    public listeTEnvoi: RFParam[] = [];
    public listeDocOrdreSave: RFTriDoc[] = [];
    public listeDocOrdre: RFTriDoc[] = [];
    private listeContactSave: Contact[] = [];
    private listeSalarieSave: Utilisateur[] = [];
    private listeAgentSave: Utilisateur[] = [];
    private idInterlocuteurService: number;

    public codeModule: string = Constantes.CodeOption.CDOCELEVEURS; // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)

    constructor() {
        super();
        this.lgTrad = {
            RET: this.translate.instant("RET"),
            TITRE: this.translate.instant("APPRECHERCHEDOCS.TITREDETAILS"),
            FORMAT: this.translate.instant("APPRECHERCHEDOCS.FORMAT"),
            SELECTFORMAT: this.translate.instant("APPRECHERCHEDOCS.SELECTFORMAT"),
            INTERLOCUTEUR: this.translate.instant('APPCLIENT.INTERLOCUTEUR'),
            DESTINATAIRE: this.translate.instant('APPCLIENT.DESTINATAIRE'),
            EXPORTDOC: this.translate.instant('APPCLIENT.EXPORTER'),
            TRIORDRE: this.translate.instant('APPCLIENT.TRIORDRE'),
            SALARIE: this.translate.instant('APPCLIENT.SALARIE'),
            AGENT: this.translate.instant('AGENT'),
            ENVOITYPE: this.translate.instant('ENVOITYPE'),
            DOCUMENT: this.translate.instant('DOC'),
            ENREGISTRER: this.translate.instant('ENR'),
            ENVOYER: this.translate.instant('ENVOYER'),
            CANCEL: this.translate.instant('CANCEL'),
            TELECHARGER: this.translate.instant('DOWNLOAD'),
            TELECHARGEMENTDOC: this.translate.instant('APPCLIENT.TELECHARGEMENTDOC')
        };
        this.formDoc = this.formBuilder.group({
            TYPEDOC: [null, Validators.required],
            DESTINATAIRE: new FormControl<RFParam[] | null>(null, Validators.required),
            TYPENVOI: [null, Validators.required],
            // 2021-08-19 TODO remettre ordre tri obligatoire et vide quand actif
            ORDRETRI: [null,]
        });
        this.dialogRef.updateSize('50vw');
    }

    ngOnInit() {
        super.ngOnInit();
        this.reset();
        this.init().catch(e => this.util.fErreur(e));
    }
    // appelé depuis la base doc
    public async init() {
        this.boEnvoi = this.data.envoi;
        try {
            this.util.showLoader();
            if (this.data.doc) {
                this.document.push(this.data.doc);
            } else {
                const controle = this.data.controle;
                const pfClient = this.getUserSession().PORTEFEUILLE;
                const client = await lastValueFrom(this.wsClient.getClientByID(controle.idClient));
                const allServices = await lastValueFrom(this.wsService.getALLServicesByClient(client.NUCHEP, client.IDCLIENT));
                const servicesActifs = allServices.filter((serv: Service) => {
                    return new Date(serv.DDEBUT) <= new Date(controle.dateDoc) && (!serv.DFIN || new Date(serv.DFIN) >= new Date(controle.dateDoc));
                });
                const services = servicesActifs.map((serv: Service) => serv.TYPESERVICE.CODESERV);
                const documents = await lastValueFrom(this.wsService.getAllDocuments([controle.idClient], services, [], controle.dateDoc, controle.dateDoc, pfClient));
                this.document = documents;
            }
            await this._show();
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    private async _show() {
        if (this.document.length > 0) {
            this.util.showLoader();
            try {
                await this.initListElement();

                if (!this.boEnvoi) {
                    this.formDoc.controls.DESTINATAIRE.disable();
                    this.formDoc.controls.TYPENVOI.disable();
                } else {
                    this.formDoc.controls.DESTINATAIRE.enable();
                    this.formDoc.controls.TYPENVOI.enable();
                }

                this.boOrdreTri = (this.document[0].SERVICE.TYPESERVICE.CODESERV == TypeService.Pesee || this.document[0].SERVICE.TYPESERVICE.CODESERV == TypeService.Mir) ? true : false;

                if (!this.boOrdreTri) {
                    this.formDoc.controls.ORDRETRI.disable();
                } else {
                    this.formDoc.controls.ORDRETRI.enable();
                }

                this.listeTypesFichiers = [{ label: 'PDF', value: TypeFichier.Pdf }];
                if (this.document[0].SERVICE.DOCUMENTS[0].TYPEDOC.CODE !== DocumentCodeEnum.GALA_TROUPO) {
                    this.listeTypesFichiers.push({ label: 'EXCEL', value: TypeFichier.Excel });
                }
            } catch (e) {
                this.util.fErreur(e);
            } finally {
                this.util.hideLoader();
            }
        } else {
            this.util.fErreur("Aucun document trouvé");
        }
    }

    // la  modal peut soit être en mode document simple, soit en mode liste (et donc contenir plusieurs documents)
    public async initListElement() {
        try {
            await Promise.all([
                lastValueFrom(this.wsCacheLow.getTypeEnvoi()),
                lastValueFrom(this.wsCacheLow.getRFTriDoc()),
                lastValueFrom(this.wsContact.getListContacts(this.document[0].SERVICE.CLIENT.NUCHEP, this.document[0].SERVICE.CLIENT.IDCLIENT)),
                lastValueFrom(this.wsUtilisateur.getUtilSalaries()),
                lastValueFrom(this.wsUtilisateur.getUtilisateursAgent(true)),
                lastValueFrom(this.wsCacheLow.getTypeDocPesee()),
                lastValueFrom(this.wsCacheLow.getTypeDocAnalyse()),
                lastValueFrom(this.wsCacheLow.getTypeDocOptimir()),
                lastValueFrom(this.wsCacheLow.getTypeDocBilan()),
                lastValueFrom(this.wsCacheLow.getTypeDocConseil()),
            ]).then((results) => {
                // Liste des ECEL
                this.listeTEnvoiSave = results[0].filter((rf: RFParam) => {
                    return rf.CODE == 'EML';
                });
                this.listeDocOrdreSave = results[1];
                this.selectTypeFichier = TypeFichier.Pdf;

                this.listeContactSave = results[2];
                this.listeSalarieSave = results[3];
                this.listeAgentSave = results[4];

                // Préparer les noms des agents
                this.listeAgentSave.forEach((ag: Utilisateur) => {
                    ag.NOM = ag.NOM + ' ' + ag.PRENOM;
                });

                // Préparer les noms des salariés
                this.listeSalarieSave.forEach((sal: Utilisateur) => {
                    sal.NOM = sal.NOM + ' ' + sal.PRENOM;
                });

                const listeDocPesee: RFParam[] = results[5];
                const listeDocAna: RFParam[] = results[6];
                const listeDocMir: RFParam[] = results[7];
                const listeDocBilan: RFParam[] = results[8];
                const listeDocConseil: RFParam[] = results[9];
                this.listeDocEnvoi = listeDocPesee.concat(listeDocAna);
                this.listeDocEnvoi = this.listeDocEnvoi.concat(listeDocMir);
                this.listeDocEnvoi = this.listeDocEnvoi.concat(listeDocBilan);
                this.listeDocEnvoi = this.listeDocEnvoi.concat(listeDocConseil);
            }).catch((error) => { throw error; });

            this.listeTEnvoi = Object.assign([], this.listeTEnvoiSave);

            this.listeDocOrdre = this.listeDocOrdreSave.filter((ordreTri: RFTriDoc) => {
                return this.document[0].SERVICE.DOCUMENTS[0].TYPEDOC.CODE == ordreTri.TYPEDOC;
            });
            this.listeDocOrdre = Object.assign([], this.listeDocOrdre);

            this.listeDocEnvoi = this.listeDocEnvoi.map((param: RFParam) => {
                return {
                    ID: param.ID,
                    CODE: param.CODE,
                    LIB: param.LIB
                };
            });

            await this.util.delay(50);
            const listeDocDispo: RFParam[] = [];
            for (const elem of this.document) {
                listeDocDispo.push(this.listeDocEnvoi.find((o: RFParam) => {
                    return elem.SERVICE.DOCUMENTS[0].TYPEDOC.CODE == o.CODE;
                }));
            }
            this.listeDocEnvoi = [...listeDocDispo];

            // Set le premier document comme sélectionné
            this.formDoc.controls.TYPEDOC.setValue(this.listeDocEnvoi[0]);
            this.selectedDocument = this.document[0];

            // Construire les listes de destinataires
            this.refreshDestinataires();

            // Quand il n'y a qu'un seul choix dans le type envoi, on le propose automatiquement
            if (this.listeTEnvoi.length === 1) {
                this.formDoc.controls.TYPENVOI.setValue(this.listeTEnvoi[0]);
            }
            this.formDoc.controls.DESTINATAIRE.setValue(this.listeDestinatairePrio);
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    public onDocChange(selectedDocType: RFParam) {
        // Trouver le document correspondant au type
        this.selectedDocument = this.document.find(
            doc => doc.SERVICE.DOCUMENTS[0].TYPEDOC.CODE === selectedDocType.CODE
        ) ?? this.document[0];

        // Recalculer les destinataires prioritaires
        this.refreshDestinataires();
    }

    private refreshDestinataires() {
        const service = this.selectedDocument.SERVICE;

        // Récupérer l'interlocuteur du service sélectionné
        this.idInterlocuteurService = service.CONTACT?.IDCONTACT;

        // Reset des listes
        this.listeDestinataire = [];
        this.listeDestinatairePrio = [];

        // Reconstruire les contacts
        for (const contact of this.listeContactSave) {
            const destinataire: RFParam & { disabled?: boolean } = {
                CODE: 'CON',
                ID: contact.IDCONTACT,
                LIB: contact.NOM + ((contact.PRENOM != null) ? ' ' + contact.PRENOM : '') + ' - ' + this.lgTrad.INTERLOCUTEUR
            };
            destinataire.disabled = !this.hasEmail(destinataire);
            if (this.idInterlocuteurService && contact.IDCONTACT === this.idInterlocuteurService) {
                this.listeDestinatairePrio.push(destinataire);
            } else {
                this.listeDestinataire.push(destinataire);
            }
        }

        // Reconstruire les salariés
        for (const sal of this.listeSalarieSave) {
            const salarie: RFParam & { disabled?: boolean } = {
                CODE: 'SAL',
                ID: sal.USRID,
                LIB: sal.NOM + ' - ' + this.lgTrad.SALARIE
            };
            salarie.disabled = !this.hasEmail(salarie);
            if (this.isReferent(salarie)) {
                if (!this.listeDestinatairePrio.find(d => d.ID === salarie.ID && d.CODE === salarie.CODE)) {
                    this.listeDestinatairePrio.push(salarie);
                }
            } else {
                this.listeDestinataire.push(salarie);
            }
        }

        // Reconstruire les agents
        for (const ag of this.listeAgentSave) {
            const agent: RFParam & { disabled?: boolean } = {
                CODE: 'AG',
                ID: ag.USRID,
                LIB: ag.NOM + ' - ' + this.lgTrad.AGENT
            };
            agent.disabled = !this.hasEmail(agent);
            if (this.isReferent(agent)) {
                if (!this.listeDestinatairePrio.find(d => d.ID === agent.ID && d.CODE === agent.CODE)) {
                    this.listeDestinatairePrio.push(agent);
                }
            } else {
                this.listeDestinataire.push(agent);
            }
        }

        this.listeDestinataire.sort((n1, n2) => n1.LIB.localeCompare(n2.LIB));
        this.sortDestinataireListe();
        this.listeDestinataire = [].concat(this.listeDestinatairePrio, this.listeDestinataire) as RFParam[];
        this.listeDestinataire = Object.assign([], this.listeDestinataire);

        // Mettre à jour la sélection par défaut
        this.formDoc.controls.DESTINATAIRE.setValue(this.listeDestinatairePrio);
    }

    public async saveDocument() {
        this.validationFormulaire(this.formDoc);
        if (this.selectTypeFichier == null) {
            this.util.showToastError(this.lgTrad.SELECTFORMAT);
            return;
        }
        if (!this.formDoc.valid) return;

        const selectedDoc = this.document.find(
            doc => doc.SERVICE.DOCUMENTS[0].TYPEDOC.CODE === this.formDoc.controls.TYPEDOC.value.CODE
        ) ?? this.document[0];

        const codeService = selectedDoc.SERVICE.TYPESERVICE.CODESERV;

        if (this.boEnvoi) {
            const destinataires = this.formDoc.controls.DESTINATAIRE.value as RFParam[];
            for (const destinataire of destinataires) {
                selectedDoc.SERVICE.DOCUMENTS[0].DESTINATAIRE = destinataire;
                selectedDoc.SERVICE.DOCUMENTS[0].TYPENVOI = this.formDoc.controls.TYPENVOI.value as RFParam;
                selectedDoc.SERVICE.DOCUMENTS[0].ORDRETRI = this.formDoc.controls.ORDRETRI.value as RFTriDoc;
                await this.envoiMail(selectedDoc, codeService);
            }
        } else {
            await this.download(selectedDoc, codeService);
        }

        this.hideModal();
    }

    private async download(doc: Document, codeService: string) {
        switch (codeService) {
            case TypeService.Analyse:
                await this.downloadAna(doc);
                break;
            case TypeService.Pesee:
                await this.downloadPesee(doc);
                break;
            case TypeService.Mir:
                await this.downloadMir(doc);
                break;
            case TypeService.Bilan:
                await this.downloadBilan(doc);
                break;
            case TypeService.Conseil:
                await this.downloadServiceConseil(doc);
                break;
        }
    }

    private async envoiMail(doc: Document, codeService: string) {
        switch (codeService) {
            case TypeService.Analyse:
                await this.envoiMailAna(doc);
                break;
            case TypeService.Conseil:
            case TypeService.Pesee:
                await this.envoiMailPesee(doc);
                break;
            case TypeService.Mir:
                await this.envoiMailMir(doc);
                break;
            case TypeService.Bilan:
                await this.envoiMailBilan(doc);
                break;
        }
    }

    public async downloadAna(doc: Document) {
        try {
            this.util.showLoader();
            const service = doc.SERVICE;
            let res: Fichier;

            if (this.selectTypeFichier == TypeFichier.Pdf) {
                res = await lastValueFrom(this.wsAnaSup.getAnalyseSup(doc.IDEVENNEMENT,
                    service.CLIENT.NUCHEP, doc.DATEEVENNEMENT, TypeFichier.Pdf));
                this.fileService.save(this.util.convertBase64toBlobPDF(res.contenu), res.nom);

            }
            else {
                res = await lastValueFrom(this.wsAnaSup.getAnalyseSup(doc.IDEVENNEMENT,
                    service.CLIENT.NUCHEP, doc.DATEEVENNEMENT, TypeFichier.Excel));
                this.fileService.save(this.util.convertBase64toBlobExcel(res.contenu), res.nom);
            }
        } catch (e) {
            this.util.fErreur(e);
        }
        this.util.hideLoader();
    }

    public async downloadMir(doc: Document) {
        try {
            this.util.showLoader();
            const service = doc.SERVICE;
            if (this.selectTypeFichier == TypeFichier.Pdf) {
                const res: Fichier = await lastValueFrom(
                    this.wsControlePerformances.getDocMir(service.CLIENT.NUCHEP,
                        doc.DATEEVENNEMENT, TypeFichier.Pdf));
                const fileName = service.CLIENT.NUCHEP + ' - Mir - ' + doc.DATEEVENNEMENT + '.pdf';
                this.fileService.save(this.util.convertBase64toBlobPDF(res.contenu), fileName);
            } else {
                const res: Fichier = await lastValueFrom(
                    this.wsControlePerformances.getDocMir(service.CLIENT.NUCHEP,
                        doc.DATEEVENNEMENT, TypeFichier.Excel));
                const fileName = service.CLIENT.NUCHEP + ' - Mir - ' + doc.DATEEVENNEMENT + '.xlsx';
                this.fileService.save(this.util.convertBase64toBlobExcel(res.contenu), fileName);
            }

        } catch (e) {
            this.util.fErreur(e);
        }
        this.util.hideLoader();
    }

    public async downloadPesee(doc: Document) {
        if (doc.SERVICE.DOCUMENTS[0].TYPEDOC.CODE == "RI") {
            await this.downloadResIndividuels(doc);
        } else if (doc.SERVICE.DOCUMENTS[0].TYPEDOC.CODE == "LR") {
            await this.downloadGalaEssentiel(doc);
        } else if (doc.SERVICE.DOCUMENTS[0].TYPEDOC.CODE == "LP") {
            await this.downloadListePesee(doc);
        }
    }

    public async downloadResIndividuels(doc: Document) {
        try {
            this.util.showLoader();
            const service = doc.SERVICE;
            if (this.selectTypeFichier == TypeFichier.Pdf) {
                const res: Fichier = await lastValueFrom(
                    this.wsControlePerformances.getResultatIndividuelPDF(service.CLIENT.NUCHEP,
                        doc.DATEEVENNEMENT, TypeFichier.Pdf));
                const fileName = service.CLIENT.NUCHEP + ' - Gala Cumuls - ' + doc.DATEEVENNEMENT + '.pdf';
                this.fileService.save(this.util.convertBase64toBlobPDF(res.contenu), fileName);
            } else {
                const res: Fichier = await lastValueFrom(
                    this.wsControlePerformances.getResultatIndividuelPDF(service.CLIENT.NUCHEP,
                        doc.DATEEVENNEMENT, TypeFichier.Excel));
                const fileName = service.CLIENT.NUCHEP + ' - Gala Cumuls - ' + doc.DATEEVENNEMENT + '.xlsx';
                this.fileService.save(this.util.convertBase64toBlobExcel(res.contenu), fileName);
            }

        } catch (e) {
            this.util.fErreur(e);
        }
        this.util.hideLoader();
    }

    public async downloadListePesee(doc: Document) {
        try {
            this.util.showLoader();
            const service = doc.SERVICE;
            // document non prévu format excel
            const res = await lastValueFrom(this.wsControlePerformances.getGalaCollect(service.CLIENT.NUCHEP,
                doc.DATEEVENNEMENT));
            const fileName = res.nom;
            this.fileService.save(this.util.convertBase64toBlob(res.contenu, res.type), fileName);
        } catch (e) {
            this.util.fErreur(e);
        }
        this.util.hideLoader();

    }


    public async downloadGalaEssentiel(doc: Document) {
        try {
            this.util.showLoader();
            const service = doc.SERVICE;
            let typeFichier: TypeFichier;
            if (this.selectTypeFichier == TypeFichier.Pdf) {
                typeFichier = TypeFichier.Pdf;
            } else {
                typeFichier = TypeFichier.Excel;
            }
            const res = await lastValueFrom(this.wsControlePerformances.getGalaEssentiel(service.CLIENT.NUCHEP,
                doc.DATEEVENNEMENT, typeFichier));
            const fileName = res.nom;
            this.fileService.save(this.util.convertBase64toBlob(res.contenu, res.type), fileName);
        } catch (e) {
            this.util.fErreur(e);
        }
        this.util.hideLoader();

    }

    public async downloadBilan(doc: Document) {
        try {
            this.util.showLoader();
            const service = doc.SERVICE;
            if (this.selectTypeFichier == TypeFichier.Pdf) {
                const res: Fichier = await lastValueFrom(
                    this.wsControlePerformances.getDocBilSynth(service.CLIENT.NUCHEP,
                        doc.DATEEVENNEMENT, TypeFichier.Pdf));
                const fileName = service.CLIENT.NUCHEP + ' - Bilan - ' + doc.DATEEVENNEMENT + '.pdf';
                this.fileService.save(this.util.convertBase64toBlobPDF(res.contenu), fileName);
            } else {
                const res: Fichier = await lastValueFrom(
                    this.wsControlePerformances.getDocBilSynth(service.CLIENT.NUCHEP,
                        doc.DATEEVENNEMENT, TypeFichier.Excel));
                const fileName = service.CLIENT.NUCHEP + ' - Bilan - ' + doc.DATEEVENNEMENT + '.xlsx';
                this.fileService.save(this.util.convertBase64toBlobExcel(res.contenu), fileName);
            }

        } catch (e) {
            this.util.fErreur(e);
        }
        this.util.hideLoader();
    }


    public async downloadServiceConseil(doc: Document) {
        try {
            this.util.showLoader();
            const service = doc.SERVICE;
            let documents: DocumentEnvoyable[];
            if (doc.SERVICE.DOCUMENTS[0].TYPEDOC.CODE == DocumentCodeEnum.GALA_QUALITE) {
                documents = [{ nom: DocumentEnum.GALA_QUALITE }];
            }
            else if (doc.SERVICE.DOCUMENTS[0].TYPEDOC.CODE == DocumentCodeEnum.GALA_REPRO) {
                documents = [{ nom: DocumentEnum.GALA_REPRO }];
            }
            else if (doc.SERVICE.DOCUMENTS[0].TYPEDOC.CODE == DocumentCodeEnum.GALA_TARIE) {
                documents = [{ nom: DocumentEnum.GALA_TARIE }];
            }
            else if (doc.SERVICE.DOCUMENTS[0].TYPEDOC.CODE == DocumentCodeEnum.GALA_TROUPO) {
                documents = [{ nom: DocumentEnum.GALA_TROUPO }];
            }
            if (this.selectTypeFichier == TypeFichier.Pdf) {
                const res: Fichier = await lastValueFrom(
                    this.wsControlePerformances.postDocumentsMultiples(service.CLIENT.NUCHEP,
                        doc.DATEEVENNEMENT, documents, null, TypeFichier.Pdf));
                this.fileService.save(this.util.convertBase64toBlobPDF(res.contenu), res.nom);
            } else {
                const res: Fichier = await lastValueFrom(
                    this.wsControlePerformances.postDocumentsMultiples(service.CLIENT.NUCHEP,
                        doc.DATEEVENNEMENT, documents, null, TypeFichier.Excel));
                this.fileService.save(this.util.convertBase64toBlobExcel(res.contenu), res.nom);
            }

        } catch (e) {
            this.util.fErreur(e);
        }
        this.util.hideLoader();
    }

    private async _envoiMailGeneric(doc: Document,
        apiMethod: (idEvennement: number, format: TypeFichier, service: Service) => Observable<unknown>
    ) {
        if (!this.document || this.document.length === 0) {
            this.util.fErreur("Aucun document sélectionné.");
            return;
        }

        const idEvennement = doc.IDEVENNEMENT;
        const service = doc.SERVICE;
        const format = this.selectTypeFichier === TypeFichier.Pdf
            ? TypeFichier.Pdf
            : TypeFichier.Excel;

        this.util.showLoader();
        try {
            await lastValueFrom(apiMethod(idEvennement, format, service));
            this.util.showToastSuccess("Mail envoyé avec succès");
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    async envoiMailAna(doc: Document) {
        try {
            await this._envoiMailGeneric(doc,
                (idEvennement, format, service) => this.wsService
                    .postAnalyseSupEnvoiMail(idEvennement, format, service)
            );
        } catch (e) {
            this.util.fErreur(e);
        }
    }

    async envoiMailMir(doc: Document) {
        try {
            await this._envoiMailGeneric(doc,
                (idEvennement, format, service) => this.wsSuivEnv
                    .postEnvoiControleMirFichier(idEvennement, format, service)
            );
        } catch (e) {
            this.util.fErreur(e);
        }
    }

    async envoiMailPesee(doc: Document) {
        try {
            await this._envoiMailGeneric(doc,
                (idEvennement, format, service) => this.wsSuivEnv
                    .postEnvoisControlePerfFichier(idEvennement, format, service)
            );
        } catch (e) {
            this.util.fErreur(e);
        }
    }

    async envoiMailBilan(doc: Document) {
        try {
            await this._envoiMailGeneric(doc,
                (idEvennement, format, service) => this.wsSuivEnv
                    .postEnvoiBilanFichier(idEvennement, format, service)
            );
        } catch (e) {
            this.util.fErreur(e);
        }
    }

    public isReferent(user: RFParam): boolean {
        if (!this.selectedDocument) {
            return false;
        }
        const service: Service = this.selectedDocument.SERVICE;
        if (user.ID == service.CLIENT.REFERENT.USRID || user.ID == service.AGENT.USRID) {
            return true;
        }
        return service.AGENTSUPP.findIndex((u: Utilisateur) => user.ID == u.USRID) > -1;
    }

    public isContact(user: RFParam): boolean {
        if (!this.selectedDocument) {
            return false;
        }
        return ('CON' === user.CODE && this.idInterlocuteurService && user.ID === this.idInterlocuteurService);
    }

    public hasEmail(user: RFParam): boolean {
        if (!this.selectedDocument) {
            return false;
        }
        let mail;
        switch (user.CODE) {
            case 'CON': mail = this.listeContactSave.find(contact => contact.IDCONTACT === user.ID)?.MAIL?.trim();
                break;
            case 'SAL': mail = this.listeSalarieSave.find(salarie => salarie.USRID === user.ID)?.MAIL?.trim();
                break;
            case 'AG': mail = this.listeAgentSave.find(agent => agent.USRID === user.ID)?.MAIL?.trim();
                break;
        }
        return mail != null && mail !== "";
    }


    selectDest($event: RFParam) {
        this.util.showLoader();
        if ($event != null) {
            if ($event.CODE == 'CON') {
                const con: Contact = this.listeContactSave.find((c: Contact) => {
                    return c.IDCONTACT == $event.ID;
                });
                if (con != null) {
                    let boOk: boolean;
                    this.listeTEnvoi = this.listeTEnvoiSave.filter((o: RFParam) => {
                        boOk = true;
                        if (o.CODE == 'SMS' && (con.TELA?.NUMERO == null)) {
                            boOk = false;
                        }
                        if (o.CODE == 'EML' && (con.MAIL == null || con.MAIL.trim() == '')) {
                            boOk = false;
                        }
                        if (o.CODE == 'COU') {
                            boOk = false;
                        }
                        if (o.CODE == 'FAX') {
                            boOk = false;
                        }
                        // if (o.CODE == 'EST') { }
                        return boOk;
                    });
                }
            } else if ($event.CODE == 'AG') {
                const util: Utilisateur = this.listeAgentSave.find((u: Utilisateur) => {
                    return u.USRID == $event.ID;
                });
                if (util != null) {
                    let boOk: boolean;
                    this.listeTEnvoi = this.listeTEnvoiSave.filter((o: RFParam) => {
                        boOk = true;
                        if (o.CODE == 'SMS' && (util.TELA?.NUMERO == null)) {
                            boOk = false;
                        }
                        if (o.CODE == 'EML' && (util.MAIL == null || util.MAIL.trim() == '')) {
                            boOk = false;
                        }
                        if (o.CODE == 'COU' && util.ADRESSEA == null) {
                            boOk = false;
                        }
                        if (o.CODE == 'FAX') {
                            boOk = false;
                        }
                        if (o.CODE == 'EST') {
                            boOk = false;
                        }
                        return boOk;
                    });
                }
            } else {
                const sal: Utilisateur = this.listeSalarieSave.find((u: Utilisateur) => {
                    return u.USRID == $event.ID;
                });
                if (sal != null) {
                    let boOk: boolean;
                    this.listeTEnvoi = this.listeTEnvoiSave.filter((o: RFParam) => {
                        boOk = true;
                        if (o.CODE == 'SMS' && (sal.TELA?.NUMERO == null)) {
                            boOk = false;
                        }
                        if (o.CODE == 'EML' && (sal.MAIL == null || sal.MAIL.trim() == '')) {
                            boOk = false;
                        }
                        if (o.CODE == 'COU' && sal.ADRESSEA == null) {
                            boOk = false;
                        }
                        if (o.CODE == 'FAX') {
                            boOk = false;
                        }
                        if (o.CODE == 'EST') {
                            boOk = false;
                        }
                        return boOk;
                    });
                }
            }
        }

        this.listeTEnvoi = Object.assign([], this.listeTEnvoi);
        this.util.hideLoader();
    }

    public hideModal() {
        this.reset();
        this.dialogRef.close();
    }

    public reset() {
        this.listeDocEnvoi = [];
        this.listeDestinataire = [];
        this.listeDestinatairePrio = [];
        this.listeTEnvoi = [];
        this.listeTypesFichiers = [];
        this.listeDocOrdre = [];
        this.document = [];
        this.formDoc.reset();
        this.formDoc.markAsUntouched();
        this.formDoc.markAsPristine();
    }

    public checkCreer(): boolean {
        return false;
    }

    sortDestinataireListe() {
        const conItems = this.listeDestinataire.filter(item => item.CODE === 'CON');
        const otherItems = this.listeDestinataire.filter(item => item.CODE !== 'CON');
        this.listeDestinataire = [...conItems, ...otherItems];
    }

    protected removeItem(item: RFParam) {
        const destinataires = this.formDoc.controls.DESTINATAIRE.value as RFParam[];
        if (destinataires.includes(item)) {
            this.formDoc.controls.DESTINATAIRE.setValue(destinataires.filter(rfParam => rfParam.ID != item.ID));
        }
    }
}
